import axios from 'axios'
import { getCookie } from '../utils/cookie'
import { Message } from 'element-ui'
import config from '../../config'

let server_api;
if (process.env.NODE_ENV === 'development') {
  server_api = config.dev.api;
} else {
  server_api = config.build.api;
}

function $http (url, options = {}) {
  // axios 配置
  const smsToken = getCookie('cookieToken');
  const crmToken = getCookie('crmToken');
  axios.defaults.timeout = 20000;
  axios.defaults.baseURL = server_api;
  axios.defaults.headers.common['Authorization'] = smsToken || crmToken;

  // 请求数据（url/method/data）
  const config = {
    url,
    ...options
  };

  // 添加请求拦截器
  // axios.interceptors.request.use(function (config) {
  //   // Do something before request is sent
  //   return config;
  // }, function (error) {
  //   // Do something with request error
  //   return Promise.reject(error);
  // });

  // 添加响应拦截器
  axios.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
  }, function (error) {
    // Do something with response error
    Message.error(`${error.response.status}: ${error.response.data.message}`);
    return error.response;
  });

  // 发起 HTTP 请求
  return axios(config)
    .then(response => {
      return response;
    });
}

export default $http;



// WEBPACK FOOTER //
// ./src/api/http.js